// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "link.chunk" + ".js?ch=" + "2a559c448f69a64d" + ".js";
};